import { 
    GET_CATEGORY,
    GET_CATEGORIES,
    SET_CATEGORIES,
    SET_LAST_CATEGORIES,
    CATEGORY_ERROR,
    CLEAR_CATEGORIES,
    CLEAR_CATEGORY,
    CATEGORIES_LOADING,
    SET_SHOW_BOTTOM_SPINNER_4_CATEGORIES,
    SET_LAST_CATEGORY_DOC,
    SET_NO_MORE_CATEGORIES
} from "../actions/types";

const initialState = {
    category: null,
    categories: [],
    no_more_categories: false,
    show_bottom_spinner: false,
    last_page_doc: 0,
    loading: true,
    modal_loading: true,
    error: {}
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case CATEGORIES_LOADING:

            // Set the loading state to true
            return {
                ...state,
                loading: true
            };
        case GET_CATEGORY:

            // Set the category state to the payload value and set loading to false
            return {
                ...state,
                category: payload,
                loading: false
            }
        case GET_CATEGORIES:

            // Set the categories state to the payload value,
            // mark all categories as read, and set loading to false
            return {
                ...state,
                categories: payload,
                loading: false
            }
        case SET_CATEGORIES: {

            // Merge the existing categories with the payload categories,
            // and update the categories state accordingly
            const categories = action.payload;
            let tempCategories = categories; 
            
            if(state.categories.length > 0) {
                tempCategories= [...state.categories, ...tempCategories ];
            }

            return {
                ...state,
                categories: tempCategories,
                loading: false
            };
        }
        case SET_LAST_CATEGORIES: {

            // Merge the existing categories with the payload categories, and update the categories state
            const categories = action.payload;
            let tempCategories = categories; 
            
            if(state.categories.length > 0) {
                tempCategories= [...state.categories, ...tempCategories ];
            }

            return {
                ...state,
                categories: tempCategories,
                no_more_categories: true,
                loading: false
            };
        }
        case CATEGORY_ERROR:

            // Set the error state to the payload value and set loading to false
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case SET_SHOW_BOTTOM_SPINNER_4_CATEGORIES:
            return {
                ...state,
                show_bottom_spinner: payload
            };
        case SET_LAST_CATEGORY_DOC:

            return {
                ...state,
                last_page_doc: payload
            };
        case SET_NO_MORE_CATEGORIES:
            return {
                ...state,
                no_more_categories: payload
            };
        case CLEAR_CATEGORY:

            // Clear the notifications state and set loading to false
            return {
                ...state,
                category: null,
                loading: false,
            }
        case CLEAR_CATEGORIES:

            // Clear the notifications state and set loading to false
            return {
                ...state,
                categories: [],
                loading: false,
            }
        default:
            return state;
    }
}